import { createFileRoute, redirect } from '@tanstack/react-router';

// [2026-06-08] /settings/integrations is gone — the Meta + Google +
// Instagram connection flow lives on /channels and was duplicated
// here. Old bookmarks land on the brand's channels page instead of
// 404'ing.
export const Route = createFileRoute('/brand/$slug/settings/integrations')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/brand/$slug/channels', params: { slug: params.slug } });
  },
});
